var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 44,
    viewBox: "0 0 59 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75439 43.2337C8.92127 43.2337 11.5088 40.6217 11.5088 37.425V0H45.1086V37.425C45.1086 40.6217 42.521 43.2337 39.3542 43.2337",
    fill: "#00B074"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5998 37.4248V33.0195H0V37.4248C0 40.6215 2.58757 43.2334 5.75445 43.2334H39.3542C36.1873 43.2334 33.5998 40.6215 33.5998 37.4248Z",
    fill: "#0A5239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 7.4458H17.5337V9.31705H21.8206V7.4458Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 7.4458H25.1419V9.31705H38.3114V7.4458Z",
    fill: "#F7C604"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 14.0732H17.5337V15.9445H21.8206V14.0732Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 14.0732H25.1419V15.9445H38.3114V14.0732Z",
    fill: "#F7C604"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 20.7007H17.5337V22.5719H21.8206V20.7007Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 20.7007H25.1419V22.5719H38.3114V20.7007Z",
    fill: "#F7C604"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 27.3281H17.5337V29.1994H21.8206V27.3281Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 27.3281H25.1419V29.1994H38.3114V27.3281Z",
    fill: "#F7C604"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.1086 27.64V5.37989C44.6452 5.30192 44.1431 5.26294 43.641 5.26294C37.5004 5.26294 32.5183 10.2919 32.5183 16.4904C32.5183 22.689 37.5004 27.7179 43.641 27.7179C44.1431 27.7569 44.6452 27.7179 45.1086 27.64Z",
    fill: "#0C1E5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5424 25.496C53.6854 25.496 58.6652 20.4692 58.6652 14.2684C58.6652 8.06755 53.6854 3.04077 47.5424 3.04077C41.3995 3.04077 36.4196 8.06755 36.4196 14.2684C36.4196 20.4692 41.3995 25.496 47.5424 25.496Z",
    fill: "#FF5B5B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5115 15.0478V8.06958H45.5722V15.0478H42.946L47.5418 20.4666L52.1376 15.0478H49.5115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview1);
export default __webpack_public_path__ + "static/media/overview-1.741a495d92bb897f6f44a3659ae60a0d.svg";
export { ForwardRef as ReactComponent };